import { render } from "./SignUpThis.vue?vue&type=template&id=5bf1dada&scoped=true&ts=true"
import script from "./SignUpThis.vue?vue&type=script&lang=ts"
export * from "./SignUpThis.vue?vue&type=script&lang=ts"

import "./SignUpThis.vue?vue&type=style&index=0&id=5bf1dada&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf1dada"]])

export default __exports__